import { css } from 'styled-components';
import { ctaStyles } from '../../styles/components.js';
import { addsMask } from '../../utils/color-manipulation.js';
import { mapBackgroundToContentColor } from '../../utils/color-mapper.js';
import 'react';
import { LinkIcon } from './shared.style.js';

/* eslint-disable @typescript-eslint/no-non-null-assertion */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const shiftIcon = (props) => css `
  ${LinkIcon} {
    transform: translateX(4px);
  }
`;
const focus = (props) => css `
    box-shadow: 0 0 0 2px
        ${mapBackgroundToContentColor({
    backgroundColor: props.backgroundColor,
    theme: props.theme,
})},
      0 0 0 4px ${props.theme.colors.background[props.backgroundColor]};
    outline: transparent solid 2px;

    ${shiftIcon}
  `;
const backgroundlessStyles = (props) => css `
  background: none;
  border: 1px solid ${props.theme.colors.content[props.color]};
  color: ${props.theme.colors.content[props.color]};
  ${ctaStyles}

  &:hover {
    ${shiftIcon}
    background: ${addsMask({
    backgroundless: true,
    color: props.theme.colors.maps.contentToBackground[props.color],
    isBackgroundColor: true,
    props,
})};
  }

  &:focus {
    ${focus}
    transition: none;
    box-shadow: 0 0 0 2px ${props.theme.colors.content[props.color]};
  }

  &:active {
    background: ${addsMask({
    backgroundless: true,
    color: props.theme.colors.maps.contentToBackground[props.color],
    isBackgroundColor: true,
    lighten: true,
    props,
})};
  }
`;
const styles = (props) => css `
  background: ${props.theme.colors.background[props.backgroundColor]};
  border: 1px solid ${props.theme.colors.background[props.backgroundColor]};
  color: ${props.theme.colors.content[props.color]};
  ${ctaStyles}

  &:hover {
    ${shiftIcon}
    background: ${(props) => addsMask({
    color: props.backgroundColor,
    isBackgroundColor: true,
    props,
})};
  }

  &:focus {
    ${focus}
  }

  &:active {
    background: ${addsMask({
    color: props.backgroundColor,
    isBackgroundColor: true,
    lighten: true,
    props,
})};
  }
`;
const ctaLinkStyles = (props) => props.backgroundless ? backgroundlessStyles : styles;

export { ctaLinkStyles };
